import React, { FC } from 'react';
import { connect } from 'react-redux';
import { Dialog, Slide } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import JobList from '../../Shared/JobList/component';
import { closeJobStatusReview, clearJobs, selectJobStatusIsOpen } from '../../../state/jobStatus';
import { IProps, IStateProps, IDispatchProps } from './interfaces';
import { IAppState } from '../../../state/reducers';

const Transition = React.forwardRef((
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
) => <Slide direction="up" ref={ref} {...props} />);

const ExchangeJobStatus: FC<IProps> = (props: IProps) => {
  const {
    isOpen,
    onClose,
    onExited,
  } = props;

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      fullScreen
      TransitionComponent={Transition}
    >
      <JobList isExchange />
    </Dialog>
  );
};

const mapStateToProps = (state: IAppState): IStateProps => ({
  isOpen: selectJobStatusIsOpen(state),
});

const mapDispatchToProps: IDispatchProps = {
  onClose: closeJobStatusReview,
  onExited: clearJobs,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExchangeJobStatus);
